var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "사업분야",
      "sc": "에프원시큐리티는 전문가들로 이루어져 있습니다.",
      "tabActive": "블록체인 사업",
      "icon": "/images/sub/visual/sv2-icon.svg",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5",
      "xl": "4",
      "data-aos": "fade-right"
    }
  }, [_c('h4', {
    staticClass: "sub-tit--md font-weight-bold"
  }, [_vm._v(" 블록체인 사업 ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7",
      "xl": "8",
      "data-aos": "fade-left"
    }
  }, [_c('p', {
    staticClass: "sub-tit--sm color-gray line-height-16 mb-8 mb-lg-16"
  }, [_vm._v(" 블록체인 사업부는 메타버스,블록체인 관련 기획 및 개발을 담당합니다. ")]), _c('p', {
    staticClass: "sub-tit--sm color-gray line-height-16"
  }, [_vm._v(" 세종대, 건양대, 극동대 등과 업무 협력 체계를 구축함 으로써 산학협력을 통한 기술 개발 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 블록체인 관련 특허를 보유하고 있습니다. "), _c('br'), _vm._v(" - 블록체인을 이용한 공동주택 관리 시스템 및 방법 "), _c('br'), _vm._v(" - 블록체인 플랫폼 사용 주체의 분산식별자 관리시스템 ")])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section bg-grey mb-110 mb-md-140 mb-lg-180"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "837",
      "src": "/images/sub/business/block/block-img.png",
      "data-aos": "fade"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "max-width": "670",
      "src": "/images/sub/business/block/block-img-mo.png",
      "data-aos": "fade"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }